/* LHC SHOP-78/79 — Kaufoptionen-Widget (Einmalkauf / Abo). Das Lieferintervall
   laeuft ueber die gemeinsame Komponente <lhc-dropdown> (assets/lhc-dropdown.js)
   statt ueber ein natives <select>. Schreibt die Auswahl in
   <input name="selling_plan"> (per form-Attribut am Produktformular).
   Einmalkauf = leerer Wert, Abo = Selling-Plan-ID. */

class LhcPurchaseOptions extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-po-input]');
    this.subPrice = this.querySelector('[data-po-sub-price]');
    this.badge = this.querySelector('[data-po-badge]');

    this.dd = this.querySelector('lhc-dropdown');

    this.addEventListener('change', (e) => {
      if (e.target.matches('[data-po-radio]')) this.onRadioChange(e.target);
    });

    this.addEventListener('lhc-dropdown:change', (e) => this.onIntervalChange(e.detail.option));

    /* Klick in die Abo-Box waehlt das Abo aus */
    const subOption = this.querySelector('[data-po-option="subscription"]');
    if (subOption) {
      subOption.addEventListener('click', () => {
        const radio = subOption.querySelector('[data-po-radio]');
        if (radio && !radio.checked) {
          radio.checked = true;
          this.onRadioChange(radio);
        }
      });
    }

  }

  /* ---------- Lieferintervall ---------- */

  /** Reagiert auf die Auswahl im gemeinsamen Dropdown. */
  onIntervalChange(opt) {
    if (!opt) return;
    const subRadio = this.querySelector('[data-po-option="subscription"] [data-po-radio]');
    if (subRadio) {
      subRadio.value = opt.dataset.value;
      if (subRadio.checked) this.input.value = opt.dataset.value;
    }
    if (this.subPrice) this.subPrice.textContent = opt.dataset.price;
  }

  /* ---------- Einmalkauf / Abo ---------- */

  onRadioChange(radio) {
    const isSubscription = radio.value !== '';
    const active = this.dd?.selectedOption;
    this.input.value = isSubscription && active ? active.dataset.value : isSubscription ? radio.value : '';
    this.querySelectorAll('[data-po-option]').forEach((el) => {
      el.classList.toggle('is-selected', el.contains(radio));
    });
    if (!isSubscription) this.dd?.close();
  }

}

if (!customElements.get('lhc-purchase-options')) {
  customElements.define('lhc-purchase-options', LhcPurchaseOptions);
}
